import View from './view';
export const PollVoteResult = View;
